
import React from "react";
import { Classname } from "@rivtn/noseur";
import { ITrophy } from "../../data";
import styles from "../../assets/style.module.css";

export interface TrophyCardProps {
    trophy: ITrophy;
}

function TrophyCard({ trophy: t }: TrophyCardProps) {
    return (<div className={Classname.build(styles["trophy"], styles[`tier-${t.tier}`])}>
        <div className={styles["trophy-top"]}>
            <span className={styles["trophy-icon"]}><i className={t.icon} /></span>
            <span className={styles["trophy-year"]}>{t.year}</span>
        </div>
        <h3 className={styles["h4"]}>{t.name}</h3>
        <span className={styles["trophy-comp"]}>{t.competition} · {t.game}</span>
        <p className={styles["trophy-desc"]}>{t.description}</p>
    </div>);
}

export default TrophyCard;
